import {
  LuHome,
  LuCalendarDays,
  LuBookOpenCheck,
  LuWallet,
  LuLibrary,
  LuLanguages,
  LuStore,
  LuUsers,
  LuGraduationCap,
  LuBriefcase,
  LuBanknote,
  LuCreditCard,
  LuSparkles,
  LuClipboardCheck,
  LuClipboardList,
  LuMessageCircle,
  LuFileText,
  LuCalendarClock,
  LuCircleDot,
  LuFilter,
} from "react-icons/lu";

// Іконка пункту меню за його посиланням. Новий пункт без іконки отримає крапку.
const NAV_ICONS = {
  general: LuHome,
  schedule: LuCalendarDays,
  homework: LuBookOpenCheck,
  payment: LuWallet,
  materials: LuLibrary,
  vocabulary: LuLanguages,
  shop: LuStore,
  "student-offerta": LuFileText,
  "teacher-offerta": LuFileText,
  "my-students": LuUsers,
  "marked-lessons": LuClipboardList,
  finance: LuBanknote,
  chat: LuMessageCircle,
  ourstudents: LuUsers,
  ourteachers: LuGraduationCap,
  ourmanagers: LuBriefcase,
  "teacher-salary": LuBanknote,
  "lesson-payment": LuCreditCard,
  funnel: LuFilter,
  "trial-lessons": LuSparkles,
  "teachers-mark": LuClipboardCheck,
  "lesson-reschedule": LuCalendarClock,
};

// Закриті пункти (у пробного учня) приходять без посилання — підбираємо іконку за назвою
const NAME_TO_LINK = {
  "Домашнє завдання": "homework",
  "Словник": "vocabulary",
  "Матеріали": "materials",
};

export const iconFor = (link, name) => NAV_ICONS[link || NAME_TO_LINK[name]] || LuCircleDot;
